:host {
  block-size: 100%;
  display: grid;
}
